<div class="notifications-panel">
    <div class="notifications-panel__header">
        <h3 class="notifications-panel__title">{{ 'in-app-notifications.panelTitle' | content }}</h3>
        <div class="notifications-panel__header-actions">
            <div class="notifications-panel__filter-wrapper" 
                [class.notifications-panel__filter-wrapper--active]="hasActiveFilters()">
                <mine-action-menu
                    class="notifications-panel__filter-menu"
                    [options]="filterMenuOptions()"
                    [panelStyle]="{ 'right': '0', 'left': 'unset' }"
                    (action)="onFilterMenuAction($event)">
                    <div class="notifications-panel__filter-icon-wrapper">
                        <svg class="notifications-panel__filter-icon">
                            <use xlink:href="assets/img/sprite.svg#icon-filter"></use>
                        </svg>
                        @if (hasActiveFilters()) {
                            <span @pimple class="notifications-panel__filter-pimple"></span>
                        }
                    </div>
                </mine-action-menu>
            </div>
            <mine-action-menu
                class="notifications-panel__action-menu medium"
                [options]="actionMenuOptions"
                [panelStyle]="{ 'right': '0', 'left': 'unset' }"
                (action)="onActionMenuClick($event)">
            </mine-action-menu>
        </div>
    </div>

    <div class="notifications-panel__body" cdkScrollable>
        @if (loading() || panelLoading()) {
            @for (i of [1, 2, 3]; track i) {
                <div class="notifications-panel__skeleton-row">
                    <ng-container *skeleton="true; width: '2rem'; height: '2rem'; style: 'border-radius: 50%; flex-shrink: 0;'"></ng-container>
                    <div class="notifications-panel__skeleton-content">
                        <ng-container *skeleton="true; width: '15.4rem'; height: '1rem'; style: 'border-radius: var(--border-radius-17);'"></ng-container>
                        <ng-container *skeleton="true; width: '10.4rem'; height: '1rem'; style: 'border-radius: var(--border-radius-17);'"></ng-container>
                    </div>
                </div>
            }
        } @else if (isFilterEmpty()) {
            <div class="notifications-panel__empty">
                <img class="notifications-panel__empty-img" [src]="emptyStateImageUrl" width="130" height="90" alt="" />
                <div class="notifications-panel__empty-texts">
                    <p class="notifications-panel__empty-title">{{ 'in-app-notifications.noUnreadEmptyState' | content }}</p>
                    <p class="notifications-panel__empty-subtitle">{{ 'in-app-notifications.noUnreadEmptyStateSubtitle' | content }}</p>
                </div>
            </div>
        } @else if (isGeneralEmpty()) {
            <div class="notifications-panel__empty">
                <img class="notifications-panel__empty-img" [src]="emptyStateImageUrl" width="130" height="90" alt="" />
                <div class="notifications-panel__empty-texts">
                    <p class="notifications-panel__empty-title">{{ 'in-app-notifications.emptyState' | content }}</p>
                    <p class="notifications-panel__empty-subtitle">{{ 'in-app-notifications.emptyStateSubtitle' | content }}</p>
                </div>
            </div>
        } @else {
            @for (group of groupedItems(); track trackByGroup($index, group)) {
                <div class="notifications-panel__group">
                    <div class="notifications-panel__group-header">
                        <span class="notifications-panel__group-label">{{ group.label | content }}</span>
                    </div>
                    @for (item of group.items; track trackByItem($index, item)) {
                        <notification-item
                            [notification]="item"
                            (itemClicked)="onItemClick($event)"
                            (markRead)="onMarkRead($event)"
                            (markUnread)="onMarkUnread($event)"
                            (deleteItem)="onDeleteItem($event)">
                        </notification-item>
                    }
                </div>
            }
        }
        @if (showLoadMore()) {
            <div class="notifications-panel__footer">
                <button
                    mine-button
                    color="secondary"
                    class="notifications-panel__load-more"
                    [disabled]="isLoadingMore()"
                    (click)="onLoadMore()">
                    <span class="notifications-panel__load-more-content">
                        @if (isLoadingMore()) {
                            <mine-spinner class="notifications-panel__load-more-spinner" [width]="16" [height]="16"></mine-spinner>
                        } @else {
                            {{ 'in-app-notifications.loadMore' | content }}
                        }
                    </span>
                </button>
            </div>
        }
    </div>
</div>
